import React, { useState } from 'react';

import Navbar from '../Components/Navbar';
import Header from '../Components/Header';
import AboutUs from '../Components/AboutUS';
import Services from '../Components/Services';
import Industries from '../Components/Industries';
import ContactUs from '../Components/ContactUs';
import Location from '../Components/Location';
import Footer from '../Components/Footer';
import Chatbot from '../Components/Chatbot';

const Home = () => {
  const [showChat, setShowChat] = useState(false);

  return (
    <div>
      <Navbar />
      <Header />
      <AboutUs />
      <Services />
      <Industries />
      <ContactUs />
      <Location />
      <Footer />

     
      <div className="chatbot-wrapper">
        <button
          onClick={() => setShowChat(!showChat)}
          className="chatbot-toggle-button"
        >
          {showChat ? 'Close Chat' : 'Ask AI'}
        </button>

        {showChat && (
          <div className="chatbot-popup">
          
            <Chatbot onClose={() => setShowChat(false)} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
